import { Route } from "react-router-dom";
import { FileModalContent, SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import { ROUTES } from "~/utils";
import {
  TransactionTablePageLoader,
  TransactionTablePageAction,
  TransactionTableDocsAction,
  TransactionTableDocsLoader,
  transactionTableShouldRevalidate,
} from "./loaders";

const TransactionTablePage = lazyNamedPage(
  "TransactionTablePage",
  () =>
    import(
      /* webpackChunkName: "transaction" */
      "./TransactionTablePage"
    ),
);

export const TransactionTableRoutes = () => {
  return (
    <>
      <Route
        loader={TransactionTablePageLoader}
        action={TransactionTablePageAction}
        shouldRevalidate={transactionTableShouldRevalidate}
        ErrorBoundary={() => SimpleErrorBoundary()}
        path="/payments"
        element={<TransactionTablePage />}
      >
        <Route
          loader={TransactionTableDocsLoader}
          action={TransactionTableDocsAction}
          ErrorBoundary={() => SimpleErrorBoundary()}
          path={ROUTES.payments + "/docs"}
          element={<FileModalContent />}
        />
      </Route>
    </>
  );
};
